<template>
  <div>
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          {{
            $t(
              parseInt($route.params.id) === 0 || $route.params.id === undefined
                ? "managementServiceOrder.addNewServiceOrder"
                : "managementServiceOrder.serviceOrderDetail"
            )
          }}
        </h3>
      </div>
      <div class="box-body">
        <div>
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group required">
                  <label class="control-label" for="">{{
                    $t("customer.apartment_code")
                  }}</label>
                  <v-select
                    class="clear"
                    :clearable="false"
                    :options="apartmentList"
                    :reduce="data => data.value"
                    :getOptionLabel="option => $t(option.text)"
                    v-model="serviceOrderData.apartmentId"
                    :placeholder="$t('customer.apartment_code')"
                    @option:selected="onSearchUserInApratment"
                    :disabled="(parseInt($route.params.id) !== 0 
                      && $route.params.id !== undefined)
                      || actionSelectFromDiagram
                    "
                  >
                    <template v-slot:option="option">
                      {{ option.text }}
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group required">
                  <label class="control-label" for="">{{
                    $t("apartmentBooking.customerName")
                  }}</label>
                  <!-- <input
                    type="text"
                    class="form-control"
                    :placeholder="$t('apartmentBooking.customerName')"
                    v-model="serviceOrderData.customerName"
                  /> -->
                  <div class="input-group">
                    <span class="form-control">{{
                      serviceOrderData.customerName
                    }}</span>
                    <span
                      class="input-group-addon btn"
                      @click="onClickEditUserInApartment"
                      ><i class="glyphicon glyphicon-edit"></i
                    ></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group required">
                  <label class="control-label" for="">{{
                    $t("apartmentBooking.phone")
                  }}</label>
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$t('apartmentBooking.phone')"
                    v-model="serviceOrderData.customerPhone"
                  />
                  <!-- <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      :placeholder="$t('apartmentBooking.phone')"
                      v-model="serviceOrderData.customerPhone"
                    />
                    <span class="input-group-addon btn"
                      ><i class="glyphicon glyphicon-search"></i
                    ></span>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group required">
                  <label class="control-label" for="">{{
                    $t("managementServiceOrder.service")
                  }}</label>
                  <v-select
                    :clearable="false"
                    :options="serviceList"
                    :reduce="data => data.value"
                    :filter="onSearchService"
                    :getOptionLabel="option => $t(option.name)"
                    :placeholder="$t('managementServiceOrder.service')"
                    @option:selected="onChangeService"
                    v-model="serviceOrderData.serviceId"
                  >
                    <template v-slot:option="option">
                      {{ option.name }}
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group required">
                  <label class="control-label" for="">{{
                    $t("managementServiceOrder.servicePackage")
                  }}</label>
                  <v-select
                    :clearable="false"
                    :options="servicePackageList"
                    :reduce="data => data.id"
                    :getOptionLabel="option => $t(option.package_name)"
                    :placeholder="$t('managementServiceOrder.servicePackage')"
                    :filter="onSearchServicePackage"
                    @option:selected="onChangeServicePackage"
                    v-model="serviceOrderData.servicePackageId"
                  >
                    <template v-slot:option="option">
                      {{ option.package_name }}
                    </template>
                  </v-select>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="">{{ $t("service.serviceUnit") }}</label>
                  <span class="form-control disable-input">{{
                    serviceOrderData.serviceUnit
                  }}</span>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="">{{
                    $t("service.servicePackage.totalFee")
                  }}</label>
                  <span class="form-control disable-input">{{
                    currencyFormat(serviceOrderData.totalFee)
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="">{{
                    $t("managementServiceOrder.dateTime")
                  }}</label>
                  <date-picker
                    class="form-control"
                    :config="timePickerOptions"
                    v-model="serviceOrderData.timeOfUse"
                    placeholder="HH:mm"
                  ></date-picker>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="">{{
                    $t("managementServiceOrder.dateOfUse")
                  }}</label>
                  <date-picker
                    class="form-control"
                    :config="datePickerOptions"
                    v-model="serviceOrderData.dateOfUse"
                    placeholder="DD-MM-YYYY"
                  ></date-picker>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="">{{ $t("managementServiceOrder.notes") }}</label>
                  <textarea
                    class="form-control"
                    name=""
                    id=""
                    cols="30"
                    rows="4"
                    :placeholder="$t('managementServiceOrder.notes')"
                    v-model="serviceOrderData.notes"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="row">
            <div class="box-footer">
              <button
                v-if="$route.params.id !== undefined"
                style="background-color: #f29911;border-color: #f29911;color:#fff"
                type="button"
                class="btn btn-default btn-sm pull-left"
                @click="onCallBack"
              >
                {{ $t("common.back") }}
              </button>
              <button
                v-else
                style="background-color: #f29911;border-color: #f29911;color:#fff"
                type="button"
                class="btn btn-default btn-sm pull-left"
                @click="onCloseModalAddService"
              >
                {{ $t("common.back") }}
              </button>
              <button
                v-if="parseInt($route.params.id) === 0 || 
                  serviceOrderData.status in [serviceOrderStatusEnum.UNFINISHED, serviceOrderStatusEnum.PAYMENT]"
                type="button"
                class="btn btn-primary btn-sm pull-right"
                @click="onSave"
              >
                {{ $t("common.save") }}
              </button>
              <!-- </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <!-- user in apartment modal -->
    <div
      class="modal fade"
      :ref="`modal-user-in-apartment-modal`"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              aria-label="Close"
              @click="onCloseUserInApartmentModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t(apartmentSelect && apartmentSelect.leasebackService 
                ? "apartmentBooking.customerList" : "apartment.apartmentMember" ) }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12"
                v-if="apartmentSelect && apartmentSelect.leasebackService">
                <b-table
                  :items="userInBookingItems"
                  :fields="userInBookingFields"
                  :tbody-tr-class="rowClass"
                  @row-clicked="onRowSelected"
                  class="mt-3"
                  outlined
                  responsive
                >
                  <template #head()="scope">
                    <div>{{ $t(scope.label) }}</div>
                  </template>
                </b-table>
              </div>
              <div v-else class="col-md-12">
                <b-table
                  :items="userInApartmentItems"
                  :fields="userInApartment"
                  :tbody-tr-class="rowClass"
                  @row-clicked="onRowSelected"
                  class="mt-3"
                  outlined
                  responsive
                >
                  <template #head()="scope">
                    <div>{{ $t(scope.label) }}</div>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              @click="onCloseUserInApartmentModal"
            >
              {{ $t("common.back") }}
            </button>
            <button
              type="button"
              class="btn btn-primary pull-right"
              @click="onSelectUserInApartmentData"
            >
              {{ $t("common.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import utils from "@/lib/utils";
import constants from "@/lib/constantsData";
import moment from "moment";
import datePicker from "vue-bootstrap-datetimepicker";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Loading from "vue-loading-overlay";
import ServiceOrderStatusEnum from "@/enum/serviceOrderStatusEnum";

export default {
  components: {
    "date-picker": datePicker,
    "lte-core-alert": LTECoreAlert,
    loading: Loading
  },
  data: () => ({
    isLoading: false,
    apartmentList: [],
    timePickerOptions: {
      format: "HH:mm",
      useCurrent: true
    },
    datePickerOptions: {
      format: "DD-MM-YYYY",
      useCurrent: false,
      minDate: moment()
    },
    serviceOrderData: {
      id: 0,
      apartmentId: null,
      userId: null,
      customerName: null,
      customerPhone: null,
      serviceId: null,
      servicePackageId: null,
      serviceUnit: null,
      totalFee: null,
      timeOfUse: null,
      dateOfUse: null,
      notes: null,
      status: null
    },
    serviceList: [],
    servicePackageList: [],
    //
    userInApartmentItems: [],
    userInApartment: [
      {
        key: "full_name",
        label: "apartment.fullname",
        sortable: true,
        class: "text-center"
      },
      {
        key: "phone",
        label: "apartment.phone",
        sortable: true,
        class: "text-center"
      },
      {
        key: "email",
        label: "apartment.email",
        sortable: true,
        class: "text-center"
      },
      {
        key: "country",
        label: "apartment.country",
        sortable: true,
        class: "text-center"
      },
      {
        key: "underAge",
        label: "customer.age",
        sortable: true,
        class: "text-center"
      },
      {
        key: "resident_status",
        label: "common.status",
        sortable: true,
        class: "text-center"
      },
      // {
      //   key: "relationship",
      //   label: "apartment.relationship",
      //   sortable: true,
      //   class: "text-center"
      // },
      {
        key: "relationship_note",
        label: "common.note",
        sortable: true,
        class: "text-center"
      }
    ],
    userInapartmentSelect: null,
    rowSelected: null,
    residentStatusOptions: constants.residentStatusOptions,
    apartmentSelect: null,
    // 
    userInBookingItems: [],
    userInBookingFields: [
      {
        label: "common.nonumber",
        key: "nonumber",
        class: "text-center "
      },
      {
        label: "apartmentBooking.customerName",
        key: "full_name",
        class: "text-center "
      },
      {
        label: "user_guest.identification",
        key: "identificationnumber",
        class: "text-center "
      },
      {
        label: "customer.phone",
        key: "phone",
        class: "text-center "
      },
      {
        label: "common.email",
        key: "customerEmail",
        class: "text-center "
      }
    ],
    actionSelectFromDiagram: false,
    serviceOrderStatusEnum: ServiceOrderStatusEnum,
    serviceOrderSelectQuery: null
  }),
  watch: {
    GET_SERVICE_LIST_ENABLE_DATA: function() {
      let data = this.GET_SERVICE_LIST_ENABLE_DATA;
      this.serviceList = [];
      data.forEach(v => {
        let item = {
          value: v.id,
          name: v.name,
          serviceUnit: v.service_unit,
          packageList: v.service_package_list
        };
        this.serviceList.push(item);
      });
    },
    GET_APARTMENT_LIST_NO_PAGE_DATA: function() {
      this.apartmentList = [];
      let data = this.GET_APARTMENT_LIST_NO_PAGE_DATA;
      data.forEach(apartment => {
        let item = {
          value: apartment.id,
          text: apartment.apartment_code,
          leasebackService: apartment.leaseback_service
        };
        this.apartmentList.push(item);
      });
    },
    GET_RESIDENT_DATA: function() {
      let data = this.GET_RESIDENT_DATA;
      this.userInApartmentItems = [];
      data.forEach((v, i) => {
        let resident = v.resident;
        let full_name = resident.last_name + " " + resident.first_name;
        let phone = resident.phone;
        let email = resident.email;
        let country_name = resident.country_name;
        let underAge = !utils.isEmptyString(resident.dob)
          ? moment().diff(resident.dob, "years") : null;
        let resident_status = this.relative_status_name(v.resident_status);
        let relationship = this.getRelationshipName(v.relationship);
        let relationship_note = v.relationship_note;
        let item = {
          id: resident.id,
          nonumber: i + 1,
          isOwner: v.isOwner,
          isMainContact: v.isMainContact,
          isTenant: v.isTenant,
          full_name: full_name,
          phone: phone,
          email: email,
          country_name: country_name,
          underAge: underAge,
          relationship: relationship,
          resident_status: resident_status,
          relationship_note: relationship_note
        };
        this.userInApartmentItems.push(item);
      });
    },
    GET_USER_BOOKING_IN_APARTMENT_DATA: function() {
      let data = this.GET_USER_BOOKING_IN_APARTMENT_DATA;
      this.userInBookingItems = [];
      data.forEach((value, index) => {
        let item = {
          nonumber: index + 1,
          id: value.id,
          full_name: value.full_name,
          identificationnumber: value.identificationnumber,
          phone: value.phone,
          customerEmail: value.email
        };
        this.userInBookingItems.push(item);
      });
    },
    GET_SERVICE_ORDER_DETAIL_DATA: async function() {
      let data = this.GET_SERVICE_ORDER_DETAIL_DATA;
      this.serviceOrderData.id = data.id;
      this.serviceOrderData.apartmentId = data.apartment;
      this.serviceOrderData.userId = data.leaseback_service ? data.user_in_booking : data.user_order;
      this.serviceOrderData.customerName = data.customer_name;
      this.serviceOrderData.customerPhone = data.customer_phone;
      this.serviceOrderData.serviceId = data.service;
      this.callbackServicePackage(data.service);
      this.serviceOrderData.servicePackageId = data.service_package;
      this.serviceOrderData.serviceUnit = data.service_unit;
      this.serviceOrderData.totalFee = data.total_fee;
      this.serviceOrderData.status = data.status
      this.serviceOrderData.timeOfUse = utils.formatSqlDate(data.date_of_use, null, "HH:mm");
      this.serviceOrderData.dateOfUse = utils.formatSqlDate(data.date_of_use, null, "DD-MM-YYYY");
      this.serviceOrderData.notes = data.description;
      //
      this.apartmentSelect = {
        id: data.apartment,
        leasebackService: data.leaseback_service
      }
      if (data.leaseback_service) {
        await this.getUserBookingInApartment();
      } else {
        await this.getResidentList();
      }
      await this.onCallBackSelectUser(this.serviceOrderData.userId, data.leaseback_service);
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_SERVICE_LIST_ENABLE_DATA",
      "GET_APARTMENT_LIST_NO_PAGE_DATA",
      "GET_RESIDENT_DATA",
      "GET_SERVICE_ORDER_DETAIL_DATA",
      "GET_USER_BOOKING_IN_APARTMENT_DATA"
    ])
  },
  methods: {
    currencyFormat: function(value) {
      if (!utils.isEmptyString(value)) {
        return utils.formatNumber(value);
      }
      return null;
    },
    onCallBack: function() {
      this.$router.push({
        name: "ManagementServiceOrder",
        query: {
          serviceOrderSelectQuery: this.serviceOrderSelectQuery
        }
      });
      // window.history.back();
    },
    onSearchService: function(options, search) {
      let resultSearch = options.filter(x =>
        utils
          .replaceCharactersVNLanguage(x.name.toLowerCase())
          .includes(utils.replaceCharactersVNLanguage(search.toLowerCase()))
      );
      return search.length > 0 && resultSearch.length > 0 ? resultSearch : [];
    },
    onChangeService: function(data) {
      if (Object.keys(data).length > 0) {
        this.servicePackageList = data.packageList;
        this.serviceOrderData.servicePackageId = null;
        this.serviceOrderData.serviceUnit = data.serviceUnit;
      }
    },
    onSearchServicePackage: function(options, search) {
      let resultSearch = options.filter(x =>
        utils
          .replaceCharactersVNLanguage(x.package_name.toLowerCase())
          .includes(utils.replaceCharactersVNLanguage(search.toLowerCase()))
      );
      return search.length > 0 && resultSearch.length > 0 ? resultSearch : [];
    },
    callbackServicePackage: function(serviceId) {
      let index = this.serviceList.findIndex(x => x.value === serviceId);
      if (index !== -1) {
        this.servicePackageList = this.serviceList[index].packageList;
      }
    },
    onChangeServicePackage: function(data) {
      if (Object.keys(data).length > 0) {
        // this.serviceOrderData.serviceUnit = data.mass_corresponding;
        this.serviceOrderData.totalFee = data.total_fee;
      }
    },
    showError: function(msg) {
      this.ON_SHOW_TOAST({
        message: this.$t(msg),
        styleType: "danger"
      });
    },
    validateData: function() {
      let validatedResult = "OK";
      if (utils.isEmptyString(this.serviceOrderData.apartmentId)) {
        validatedResult = this.$t("customer.apartment_code");
      } else if (utils.isEmptyString(this.serviceOrderData.customerName)) {
        validatedResult = this.$t("apartmentBooking.customerName");
      } else if (utils.isEmptyString(this.serviceOrderData.customerPhone)) {
        validatedResult = this.$t("apartmentBooking.phone");
      } else if (utils.isEmptyString(this.serviceOrderData.serviceId)) {
        validatedResult = this.$t("managementServiceOrder.service");
      } else if (utils.isEmptyString(this.serviceOrderData.servicePackageId)) {
        validatedResult = this.$t("managementServiceOrder.servicePackage");
      } else if (utils.isEmptyString(this.serviceOrderData.dateOfUse)) {
        validatedResult = this.$t("managementServiceOrder.dateOfUse");
      } else if (utils.isEmptyString(this.serviceOrderData.timeOfUse)) {
        validatedResult = this.$t("managementServiceOrder.timeOfUse");
      }
      return validatedResult;
    },
    getDateOfUse: function() {
      let results = null;
      if (!utils.isEmptyString(this.serviceOrderData.dateOfUse)) {
        if (!utils.isEmptyString(this.serviceOrderData.timeOfUse)) {
          let time = `${this.serviceOrderData.timeOfUse} ${this.serviceOrderData.dateOfUse}`;
          results = utils.formatSqlUtcDate(time, "HH:mm DD-MM-YYYY", "YYYY-MM-DD HH:mm");
        } else {
          results = utils.formatSqlUtcDate(this.serviceOrderData.dateOfUse, "DD-MM-YYYY", "YYYY-MM-DD HH:mm");
        }
      }
      return results;
    },
    onSave: function() {
      let results = this.validateData();
      if (results === "OK") {
        let data = {
          id: this.serviceOrderData.id,
          serviceId: this.serviceOrderData.serviceId,
          servicePackageId: this.serviceOrderData.servicePackageId,
          apartmentId: this.serviceOrderData.apartmentId,
          customerName: this.serviceOrderData.customerName,
          customerPhone: this.serviceOrderData.customerPhone,
          totalFee: this.serviceOrderData.totalFee,
          serviceUnit: this.serviceOrderData.serviceUnit,
          dateOfUse: this.getDateOfUse(),
          description: this.serviceOrderData.notes,
          userInApartmentId: null,
          userInBooking: null
        };
        if (this.apartmentSelect.leasebackService) {
          data.userInBooking = this.serviceOrderData.userId
        } else {
          data.userInApartmentId = this.serviceOrderData.userId
        }
        this.isLoading = true
        if (this.serviceOrderData.id === 0 || this.$route.params.id === undefined) {
          this.ADD_SERVICE_ORDER(data)
            .then(
              function() {
                this.isLoading = false
                this.SUCCESS_TOAST();
                if (this.$route.params.id !== undefined) {
                  this.onCallBack();
                } else {
                  this.onCloseModalAddService()
                }
              }.bind(this)
            )
            .catch(
              function(error) {
                this.isLoading = false
                this.ON_SHOW_TOAST({
                  message: error.response.data.message,
                  styleType: "danger"
                });
              }.bind(this)
            );
        } else {
          this.UPDATE_SERVICE_ORDER(data)
            .then(
              function() {
                this.isLoading = false
                this.SUCCESS_TOAST();
                this.onCallBack();
              }.bind(this)
            )
            .catch(
              function(error) {
                this.isLoading = false
                this.ON_SHOW_TOAST({
                  message: error.response.data.message,
                  styleType: "danger"
                });
              }.bind(this)
            );
        }
        //
      } else {
        this.showError(results);
      }
    },
    getServiceListEnable: function() {
      this.GET_SERVICE_LIST_ENABLE();
    },
    //
    onCallBackSelectUser: function(userId, leasebackService) {
      if (leasebackService) {
        // 
      } else {
        let index = this.userInApartmentItems.findIndex(x => x.id === userId);
        if (index !== -1) {
          this.rowSelected = index + 1;
          this.serviceOrderData.userId = this.userInApartmentItems[index];
        }
      }
    },
    rowClass(item, type) {
      if (!item || type !== "row") return;

      if (item.nonumber === this.rowSelected) {
        return "row-selected-class";
      } else {
        if (item.isOwner) return "owner-resident-class";
        if (item.isTenant) return "tenant-resident-class";
      }
    },
    onRowSelected: function(items, index) {
      this.rowSelected = index + 1;
      this.userInapartmentSelect = items;
    },
    relative_status_name: function(status_id) {
      for (let i = 0; i < this.residentStatusOptions.length; i++) {
        let status = this.residentStatusOptions[i];
        if (status.value === status_id) {
          return status.text;
        }
      }
      return status_id;
    },
    getRelationshipName: function(status_id) {
      return utils.getRelationshipName(status_id)
    },
    onCloseUserInApartmentModal: function() {
      $(this.$refs[`modal-user-in-apartment-modal`]).modal("hide");
    },
    onShowUserInApartmentModal: function() {
      $(this.$refs[`modal-user-in-apartment-modal`]).modal("show");
    },
    getResidentList: function() {
      let filter = {
        params: {
          apartment: this.serviceOrderData.apartmentId
        }
      };
      this.GET_RESIDENT_LIST(filter);
    },
    onSearchUserInApratment: function(data) {
      this.apartmentSelect = data
      if (data.leasebackService) {
        this.getUserBookingInApartment()
      } else {
        this.getResidentList();
      }
      if (!this.actionSelectFromDiagram) {
        this.onShowUserInApartmentModal();
      }
      this.serviceOrderData.userId = null
      this.serviceOrderData.customerName = null
      this.serviceOrderData.customerPhone = null
      this.userInapartmentSelect = null
      this.rowSelected = null
    },
    onSelectUserInApartmentData: function() {
      if (!utils.isEmptyString(this.userInapartmentSelect)) {
        this.serviceOrderData.userId =
          this.userInapartmentSelect && this.userInapartmentSelect.id;
        this.serviceOrderData.customerName =
          this.userInapartmentSelect && this.userInapartmentSelect.full_name;
        this.serviceOrderData.customerPhone =
          this.userInapartmentSelect && this.userInapartmentSelect.phone;
        this.onCloseUserInApartmentModal();
      } else {
        this.showError(
          this.$t("managementServiceOrder.errorSelectUserInApartment")
        );
      }
    },
    onClickEditUserInApartment: function() {
      if (this.userInApartmentItems.length > 0)  {
        this.onShowUserInApartmentModal()
      } else {
        this.onShowUserInApartmentModal()
      }
    },
    getUserBookingInApartment: function() {
      let filter = {
        params: {
          apartmentId: this.serviceOrderData.apartmentId,
          leasebackService: true
        }
      };
      this.GET_USER_BOOKING_IN_APARTMENT(filter);
    },
    onCloseModalAddService: function() {
      this.$emit('onCloseModalAddService', true)
    },
    onGetDataFromApartmentDiagram: function(apartementId) {
      this.actionSelectFromDiagram = true
      this.serviceOrderData.apartmentId = apartementId
      let index = this.apartmentList.findIndex(x=>x.value === apartementId)
      if (index !== -1) {
        this.onSearchUserInApratment(this.apartmentList[index])
      }
      this.serviceOrderData.serviceId = null
      this.serviceOrderData.servicePackageId = null
      this.serviceOrderData.totalFee = null;
      this.serviceOrderData.timeOfUse = null
      this.serviceOrderData.dateOfUse = null
    },
    ...mapActions([
      "ON_SHOW_TOAST",
      "SUCCESS_TOAST",
      "GET_SERVICE_LIST_ENABLE",
      "ADD_SERVICE_ORDER",
      "UPDATE_SERVICE_ORDER",
      "GET_APARTMENT_LIST",
      "GET_SERVICE_ORDER_DETAIL",
      "GET_RESIDENT_LIST",
      "GET_USER_BOOKING_IN_APARTMENT"
    ])
  },
  async mounted() {
    let serviceOrderSelectQuery = this.$route.query.serviceOrderSelectQuery
    if (serviceOrderSelectQuery !== undefined) {
      this.serviceOrderSelectQuery = serviceOrderSelectQuery
    }
    await this.getServiceListEnable();
    // get all apartment
    let apartmentFilter = {
      params: {
        asset: "asset"
      }
    };
    this.isLoading = true;
    await this.GET_APARTMENT_LIST(apartmentFilter)
      .then(
        function() {
          this.isLoading = false;
        }.bind(this)
      )
      .catch(
        function() {
          this.isLoading = false;
        }.bind(this)
      );
    //
    let id = this.$route.params.id;
    if (parseInt(id) !== 0 && id !== undefined) {
      await this.GET_SERVICE_ORDER_DETAIL({ id: id });
    }
  }
};
</script>
<style lang="scss" scoped>
.form-group.required .control-label:after {
  content: " *";
  color: red;
  position: absolute;
  margin-left: 8px;
  top: 0px;
}

.disable-input {
  background: #e4e7e8;
}

.table-responsive :deep(.b-table .owner-resident-class) {
  background-color: #26ba50;
}

.table-responsive :deep(.b-table .tenant-resident-class) {
  background-color: #00bcd4;
}

.table-responsive :deep(.b-table .row-selected-class) {
  background-color: #cccccc;
}
</style>



// WEBPACK FOOTER //
// src/views/Service/ManagementServiceOrderDetail.vue